import { render, staticRenderFns } from "./AssigneesWithVariables.vue?vue&type=template&id=47cbd0c8&scoped=true&"
import script from "./AssigneesWithVariables.vue?vue&type=script&lang=js&"
export * from "./AssigneesWithVariables.vue?vue&type=script&lang=js&"
import style0 from "./AssigneesWithVariables.vue?vue&type=style&index=0&id=47cbd0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbd0c8",
  null
  
)

export default component.exports